// extracted by mini-css-extract-plugin
export default {"formContainer":"StoryAndRules_formContainer__wJIUs","titleRow":"StoryAndRules_titleRow__Pc4KQ","titleTooltip":"StoryAndRules_titleTooltip__PJh2w"};